// sidebar menu
// name = menu name
// screen = navigator name
// stack_screen = stack screen that you want to go to
// permission = permission menu to hide/show the menu (based on role and this is handle on sociolla-core/lib/access-controls/b2b.js)
// permission = it can be more than one permission
// childs = if the menu have child menu and it will be as dropdown menu
// customParams = if you need default parameter when open the menu
// external_url = if set, this menu is a pure external link (no internal screen) — pressing it opens external_url in a new tab (web) or via Linking (native), see goToMenu in DrawerMenu.js
import { getEnvironment } from '@global/helpers';

const Config = getEnvironment();

export const MENUS = [
  {
    name: 'Dashboard',
    icon: require('@assets/img/icons/menu/home.svg'),
    icon_active: require('@assets/img/icons/menu/home-active.svg'),
    screen: 'HomeNavigator',
    permissions: [],
  },
  {
    name: 'Business Tracker',
    icon: require('@assets/img/icons/menu/business-tracker.svg'),
    icon_active: require('@assets/img/icons/menu/business-tracker-active.svg'),
    permissions: [],
    childs: [
      {
        name: 'Sales',
        icon: require('@assets/img/icons/menu/business-tracker.svg'),
        icon_active: require('@assets/img/icons/menu/business-tracker-active.svg'),
        screen: 'BusinessTrackerNavigator',
        stack_screen: 'BusinessTrackerScreen',
        customParams: { tab: 'sales' },
        permissions: [],
      },
      {
        name: 'Goods Received Note',
        icon: require('@assets/img/icons/menu/LPB.svg'),
        icon_active: require('@assets/img/icons/menu/LPB-active.svg'),
        screen: 'BusinessTrackerNavigator',
        stack_screen: 'BusinessTrackerScreen',
        customParams: { tab: 'grn' },
        permissions: ['LPB'],
      },
      {
        name: 'Sales Activity',
        icon: require('@assets/img/icons/menu/skp.svg'),
        icon_active: require('@assets/img/icons/menu/skp.svg'),
        screen: 'BusinessTrackerNavigator',
        stack_screen: 'SalesmanDashboardScreen',
        permissions: ['ViewDashboard'],
      },
    ],
  },
  {
    name: 'Calendar',
    icon: require('@assets/img/icons/menu/calendar.svg'),
    icon_active: require('@assets/img/icons/menu/calendar-active.svg'),
    screen: 'CalendarNavigator',
    stack_screen: 'CalendarScreen',
    permissions: ['Calender'],
  },
  {
    name: 'Sales Activity',
    icon: require('@assets/img/icons/menu/sales-activity.svg'),
    icon_active: require('@assets/img/icons/menu/sales-activity-active.svg'),
    screen: 'SalesActivityNavigator',
    stack_screen: 'SalesActivityScreen',
    permissions: ['SalesActivity'],
  },
  {
    name: 'Product Catalog',
    icon: require('@assets/img/icons/menu/catalog.svg'),
    icon_active: require('@assets/img/icons/menu/catalog-active.svg'),
    screen: 'CatalogNavigator',
    stack_screen: 'CatalogScreen',
    permissions: ['Product'],
  },
  {
    name: 'Transaction',
    icon: require('@assets/img/icons/menu/transaction.svg'),
    icon_active: require('@assets/img/icons/menu/transaction-active.svg'),
    permissions: ['Order', 'OrderCreate'],
    hiddenForRoles: ['collector'],
    childs: [
      // {
      //   name: 'Product Catalog',
      //   icon: require('@assets/img/icons/menu/product-catalog.svg'),
      //   icon_active: require('@assets/img/icons/menu/product-catalog-active.svg'),
      //   screen: 'BrandCatalogNavigator',
      //   permissions: ['Product'],
      // },
      {
        name: 'Sales Order',
        icon: require('@assets/img/icons/menu/sales-order.svg'),
        icon_active: require('@assets/img/icons/menu/sales-order-active.svg'),
        screen: 'SalesOrderNavigator',
        stack_screen: 'SalesOrderScreen',
        customParams: { customerId: '', titleScreen: '' },
        permissions: ['Order'],
      },
      {
        name: 'Add Sales Order',
        icon: require('@assets/img/icons/menu/create-sales-order.svg'),
        icon_active: require('@assets/img/icons/menu/create-sales-order-active.svg'),
        screen: 'SalesOrderNavigator',
        stack_screen: 'SalesOrderFormScreen',
        previous: 'SalesOrderScreen',
        is_form: true,
        permissions: ['OrderCreate'],
      },
      {
        name: 'Return Order',
        icon: require('@assets/img/icons/menu/return-order.svg'),
        icon_active: require('@assets/img/icons/menu/sales-order-active.svg'),
        screen: 'ReturnOrderNavigator',
        stack_screen: 'ReturnOrderScreen',
        customParams: { customerId: '', titleScreen: '' },
        permissions: ['Order'],
        hiddenForRoles: ['collector'],
      },
      {
        name: 'Add Return Order',
        icon: require('@assets/img/icons/menu/create-sales-order.svg'),
        icon_active: require('@assets/img/icons/menu/create-sales-order-active.svg'),
        screen: 'ReturnOrderNavigator',
        stack_screen: 'ReturnOrderFormScreen',
        previous: 'ReturnOrderScreen',
        is_form: true,
        permissions: ['OrderCreate'],
      },
      {
        name: 'Add Sales Order Spreading',
        icon: require('@assets/img/icons/menu/sales-order-spreading.svg'),
        icon_active: require('@assets/img/icons/menu/sales-order-spreading-active.svg'),
        screen: 'SalesOrderNavigator',
        stack_screen: 'SalesOrderFormScreen',
        previous: 'SalesOrderScreen',
        // is_form: true,
        customParams: {
          order_type: 'spreading',
          id: '',
          name: '',
          titleScreen: '',
          firstAdded: '',
        },
        permissions: ['SalesOrderSpreading'],
      },
    ],
  },
  {
    name: 'Inventory',
    icon: require('@assets/img/icons/menu/inventory-list.svg'),
    icon_active: require('@assets/img/icons/menu/inventory-list-active.svg'),
    permissions: ['Inventory'],
    childs: [
      {
        name: 'List',
        icon: require('@assets/img/icons/menu/inventory-list.svg'),
        icon_active: require('@assets/img/icons/menu/inventory-list-active.svg'),
        screen: 'InventoryNavigator',
        stack_screen: 'InventoryScreen',
        permissions: ['Inventory'],
      },
      {
        name: 'Summary',
        icon: require('@assets/img/icons/menu/inventory-summary.svg'),
        icon_active: require('@assets/img/icons/menu/inventory-summary-active.svg'),
        screen: 'InventoryNavigator',
        stack_screen: 'InventorySummaryScreen',
        permissions: ['Inventory'],
      },
    ],
  },
  {
    name: 'Customer',
    icon: require('@assets/img/icons/menu/customer.svg'),
    icon_active: require('@assets/img/icons/menu/customer-active.svg'),
    permissions: ['Customer', 'CustomerCreate', 'LoyaltyPointTransaction'],
    childs: [
      {
        name: 'All',
        icon: require('@assets/img/icons/menu/customer.svg'),
        icon_active: require('@assets/img/icons/menu/customer-active.svg'),
        screen: 'CustomerNavigator',
        stack_screen: 'CustomerScreen',
        permissions: ['Customer'],
        customParams: { isHome: '', sidebar: true },
      },
      // {
      //   name: 'Loyalty Point',
      //   icon: require('@assets/img/icons/menu/loyalty-point.svg'),
      //   icon_active: require('@assets/img/icons/menu/loyalty-point-active.svg'),
      //   screen: 'LoyaltyNavigator',
      //   stack_screen: 'LoyaltyScreen',
      //   permissions: ['LoyaltyPointTransaction'],
      // },
      {
        name: 'Customer Registration',
        icon: require('@assets/img/icons/menu/customer-registration.svg'),
        icon_active: require('@assets/img/icons/menu/customer-registration-active.svg'),
        screen: 'CustomerRegisterNavigator',
        stack_screen: 'CustomerRegistrationScreen',
        is_form: true,
        // confirm_leave: true,
        // roles: ['superadmin', 'sales_admin', 'salesman', 'sales_supervisor'],
        permissions: ['CustomerCreate'],
      },
    ],
  },
  {
    name: 'Promotion Agreement Form',
    icon: require('@assets/img/icons/menu/skp.svg'),
    icon_active: require('@assets/img/icons/menu/skp.svg'),
    permissions: [
      'SkpInternal',
      'SkpInternalCreate',
      'SkpExternal',
      'SkpExternalCreate',
    ],
    childs: [
      {
        name: 'SKP Internal',
        icon: require('@assets/img/icons/menu/skp.svg'),
        icon_active: require('@assets/img/icons/menu/skp-active.svg'),
        screen: 'SkpInternalNavigator',
        stack_screen: 'SkpInternalScreen',
        permissions: ['SkpInternal'],
        customParams: { isHome: '', sidebar: true },
      },
      {
        name: 'Add SKP Internal',
        icon: require('@assets/img/icons/menu/create-skp.svg'),
        icon_active: require('@assets/img/icons/menu/create-skp-active.svg'),
        screen: 'SkpInternalNavigator',
        stack_screen: 'SkpInternalFormScreen',
        previous: 'SkpInternalScreen',
        is_form: true,
        permissions: ['SkpInternalCreate'],
      },
      {
        name: 'SKP External',
        icon: require('@assets/img/icons/menu/skp.svg'),
        icon_active: require('@assets/img/icons/menu/skp-active.svg'),
        screen: 'SkpExternalNavigator',
        stack_screen: 'SkpExternalScreen',
        permissions: ['SkpExternal'],
        customParams: { isHome: '', sidebar: true },
      },
      {
        name: 'Add SKP External',
        icon: require('@assets/img/icons/menu/create-skp.svg'),
        icon_active: require('@assets/img/icons/menu/create-skp-active.svg'),
        screen: 'SkpExternalNavigator',
        stack_screen: 'SkpExternalFormScreen',
        previous: 'SkpExternalScreen',
        is_form: true,
        permissions: ['SkpExternalCreate'],
      },
    ],
  },
  {
    name: 'Goods Received Note',
    icon: require('@assets/img/icons/menu/LPB.svg'),
    icon_active: require('@assets/img/icons/menu/LPB-active.svg'),
    permissions: ['LPB'],
    screen: 'LPBNavigator',
    stack_screen: 'LPBScreen',
    // childs: [
    //   {
    //     name: '3PL LPB',
    //     icon: require('@assets/img/icons/menu/LPB.svg'),
    //     icon_active: require('@assets/img/icons/menu/LPB-active.svg'),
    //     screen: 'LPBNavigator',
    //     stack_screen: 'LPBScreen',
    //     permissions: ['SkpExternal'],
    //     customParams: { isHome: '', sidebar: true },
    //   },
    //   {
    //     name: 'Add 3PL LPB',
    //     icon: require('@assets/img/icons/menu/create-skp.svg'),
    //     icon_active: require('@assets/img/icons/menu/create-skp-active.svg'),
    //     screen: 'LPBNavigator',
    //     stack_screen: 'LPBFormScreen',
    //     previous: 'LPBScreen',
    //     is_form: true,
    //     permissions: ['SkpExternalCreate'],
    //   },
    // ],
  },
  // {
  //   name: 'Stock Tracker',
  //   icon: require('@assets/img/icons/menu/stock-tracker.svg'),
  //   icon_active: require('@assets/img/icons/menu/stock-tracker-active.svg'),
  //   screen: 'HomeNavigator',
  //   permissions: ['StockTracker'],
  // },
  {
    name: 'Sub Distributor',
    icon: require('@assets/img/icons/menu/catalog.svg'),
    icon_active: require('@assets/img/icons/menu/catalog-active.svg'),
    permissions: ['Outlet', 'OutletCreate'],
    childs: [
      {
        name: 'All',
        icon: require('@assets/img/icons/menu/catalog.svg'),
        icon_active: require('@assets/img/icons/menu/catalog-active.svg'),
        screen: 'SubdistributorNavigator',
        stack_screen: 'SubdistributorScreen',
        permissions: ['Outlet'],
      },
      {
        name: 'Sub Distributor Registration',
        icon: require('@assets/img/icons/menu/create-sales-order.svg'),
        icon_active: require('@assets/img/icons/menu/create-sales-order-active.svg'),
        screen: 'SubdistributorNavigator',
        stack_screen: 'SubdistributorFormScreen',
        is_form: true,
        permissions: ['OutletCreate'],
      },
    ],
  },
  {
    name: 'Request Product',
    icon: require('@assets/img/icons/menu/skp.svg'),
    icon_active: require('@assets/img/icons/menu/skp.svg'),
    permissions: ['RequestProduct', 'RequestProductEligibilities'],
    childs: [
      {
        name: 'Request Product List',
        icon: require('@assets/img/icons/menu/skp.svg'),
        icon_active: require('@assets/img/icons/menu/skp.svg'),
        screen: 'RequestProductNavigator',
        stack_screen: 'RequestProductListScreen',
        permissions: ['RequestProduct'],
      },
      {
        name: 'Product Listing & Summary',
        icon: require('@assets/img/icons/menu/inventory-summary.svg'),
        icon_active: require('@assets/img/icons/menu/inventory-summary-active.svg'),
        screen: 'RequestProductNavigator',
        stack_screen: 'RequestProductPeriodScreen',
        permissions: ['RequestProductEligibilities'],
      },
    ],
  },
  {
    name: 'Product Stock',
    icon: require('@assets/img/icons/menu/inventory-list.svg'),
    icon_active: require('@assets/img/icons/menu/inventory-list-active.svg'),
    screen: 'ProductStockNavigator',
    stack_screen: 'ProductStockScreen',
    permissions: ['ProductStock'],
  },
  {
    name: 'Learning Management System',
    icon: require('@assets/img/icons/menu/lms.svg'),
    icon_active: require('@assets/img/icons/menu/lms-active.svg'),
    external_url: Config.LMS_WEB_URL,
    permissions: ['LearningManagementSystem'],
  },
].sort((a, b) => a.name.localeCompare(b.name));

// Setting configuration (menu and permission)
export const SETTING_PERMISSION = [
  'Branches',
  'Brand',
  'Pricelist',
  'Planogram',
  'LoyaltyPointRules',
  'SalesTarget',
  'Incentive',
  'Users',
  'SalesTeam',
  'MarketBusinessType',
  'PromotionRules',
  'CustomerCluster',
  'MatrixApproval',
  'NewArrivalBestSeller',
  'CMS',
  'PromotionAccounts',
];

export const SETTING_MENUS = [
  {
    name: 'Branch List',
    screen: 'BranchListNavigator',
    stack_screen: 'BranchListScreen',
    setting_child: true,
    permissions: ['Branches'],
  },
  {
    name: 'Brand',
    screen: 'BrandNavigator',
    stack_screen: 'BrandScreen',
    setting_child: true,
    permissions: ['Brands'],
  },
  {
    name: 'Pricelist',
    screen: 'PricelistNavigator',
    stack_screen: 'PricelistScreen',
    setting_child: true,
    permissions: ['Pricelist'],
  },
  {
    name: 'Planogram',
    screen: 'PlanogramNavigator',
    stack_screen: 'PlanogramScreen',
    setting_child: true,
    permissions: ['Planogram'],
    hiddenForRoles: ['promotor'],
  },
  {
    name: 'Loyalty Point Setup',
    screen: 'LoyaltyPointNavigator',
    stack_screen: 'LoyaltySetupScreen',
    setting_child: true,
    permissions: ['LoyaltyPointRules'],
  },
  {
    name: 'Sales Target Setup',
    screen: 'HomeNavigator',
    setting_child: true,
    permissions: ['SalesTarget'],
  },
  {
    name: 'Incentive',
    screen: 'HomeNavigator',
    setting_child: true,
    permissions: ['Incentive'],
    hiddenForRoles: ['promotor'],
  },
  {
    name: 'User Settings',
    screen: 'UserNavigator',
    stack_screen: 'UsersScreen',
    setting_child: true,
    permissions: ['Users'],
  },
  {
    name: 'Sales Team',
    screen: 'SalesTeamNavigator',
    stack_screen: 'SalesTeamScreen',
    setting_child: true,
    permissions: ['SalesTeam'],
  },
  {
    name: 'Market & Business Type',
    screen: 'MarketBusinessTypeNavigator',
    stack_screen: 'MarketBusinessTypeScreen',
    setting_child: true,
    permissions: ['MarketBusinessType'],
  },
  {
    name: 'Account Group',
    screen: 'AccountGroupNavigator',
    stack_screen: 'AccountGroupScreen',
    setting_child: true,
    permissions: ['MarketBusinessType'],
  },
  {
    name: 'Promotion Rules',
    screen: 'PromotionRulesNavigator',
    stack_screen: 'PromotionRulesScreen',
    setting_child: true,
    // permissions: ['PromotionRules']
    permissions: [],
    hiddenForRoles: ['collector'],
  },
  {
    name: 'Customer Cluster',
    screen: 'CustomerClusterNavigator',
    stack_screen: 'CustomerClusterScreen',
    setting_child: true,
    // permissions: ['PromotionRules']
    permissions: [],
    hiddenForRoles: ['promotor', 'collector'],
  },
  {
    name: 'Customer Type',
    screen: 'CustomerTypeNavigator',
    stack_screen: 'CustomerTypeScreen',
    setting_child: true,
    permissions: [],
    hiddenForRoles: ['promotor', 'collector'],
  },
  {
    name: 'Matrix Approval',
    screen: 'MatrixApprovalNavigator',
    stack_screen: 'MatrixApprovalScreen',
    setting_child: true,
    permissions: ['MatrixApproval'],
    hiddenForRoles: ['promotor'],
  },
  {
    name: 'Best Seller / New Arrival',
    screen: 'NewArrivalBestSellerNavigator',
    stack_screen: 'NewArrivalBestSellerScreen',
    setting_child: true,
    permissions: ['NewArrivalBestSeller'],
  },
  {
    name: 'CMS',
    screen: 'CMSNavigator',
    stack_screen: 'CMSScreen',
    setting_child: true,
    permissions: ['CMS'],
    hiddenForRoles: ['collector'],
  },
  {
    name: 'Budget Pocket',
    screen: 'BudgetPocketNavigator',
    stack_screen: 'BudgetPocketScreen',
    setting_child: true,
    permissions: ['BudgetPocket'],
  },
  {
    name: 'Target Setting',
    screen: 'TargetSettingNavigator',
    stack_screen: 'TargetSettingScreen',
    setting_child: true,
    permissions: ['TargetSetting'],
  },
  {
    name: 'COA Tax Setting',
    screen: 'CoaTaxSettingNavigator',
    stack_screen: 'CoaTaxSettingScreen',
    setting_child: true,
    permissions: ['CoaTaxSetting'],
  },
  {
    name: 'Customer Credit Limit',
    screen: 'CreditLimitNavigator',
    stack_screen: 'CreditLimitScreen',
    setting_child: true,
    permissions: ['CreditLimit'],
  },
  {
    name: 'Forecast Stock',
    screen: 'ForecastStockNavigator',
    stack_screen: 'ForecastStockScreen',
    setting_child: true,
    permissions: ['ForecastStock'],
  },
  {
    name: 'Promotion Account',
    screen: 'PromotionAccountNavigator',
    stack_screen: 'PromotionAccountScreen',
    setting_child: true,
    permissions: ['PromotionAccounts'],
    hiddenForRoles: ['promotor'],
  },
].sort((a, b) => a.name.localeCompare(b.name));

// this menu will show when you are open page from setting button on the top right side web or mobile web
export const SETTINGS = [
  {
    name: 'Back to Dashboard',
    icon: require('@assets/img/icons/arrow-left-white.svg'),
    icon_active: require('@assets/img/icons/arrow-left-white.svg'),
    screen: 'HomeNavigator',
    back: true,
    permissions: [],
  },
  {
    name: 'Setting',
    icon: require('@assets/img/icons/setting.svg'),
    icon_active: require('@assets/img/icons/setting.svg'),
    permissions: SETTING_PERMISSION,
    childs: SETTING_MENUS,
  },
];
